import { InertiaForm } from '@inertiajs/vue3';
import type { ZodSchema } from 'zod';

export function useZodValidation<T extends Record<string, any>>(schema: ZodSchema, form: InertiaForm<T>) {
  function validate({ clearErrors = true }: { clearErrors?: boolean } = {}) {
    if (clearErrors) {
      form.clearErrors()
    }

    const result = schema.safeParse(form.data())

    if (!result.success) {
      result.error.errors.forEach((error) => {
        const formData = form.data()
        const field = error.path[0] as keyof typeof formData
        form.setError(field as any, error.message)
      })

      return false
    }

    return true
  }

  return { validate }
}
